import { ChevronRight } from "lucide-react";

interface Props {
  title: string;
  onBack?: () => void;
  right?: React.ReactNode;
}

export function ScreenHeader({ title, onBack, right }: Props) {
  const side = right ? { width: 84 } : undefined;
  return (
    <div className="sticky top-0 z-20 flex items-center glass-surface px-2 py-3 shrink-0">
      <div className={right ? "flex justify-start" : "w-10 flex justify-start"} style={side}>
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            aria-label="رجوع"
            className="w-9 h-9 flex items-center justify-center rounded-full active:bg-white/10"
          >
            {/* In an RTL layout "back" points toward the right, matching
                the reading direction, so this stays consistent with
                Telegram's own native BackButton placement/direction. */}
            <ChevronRight size={20} strokeWidth={2.25} />
          </button>
        )}
      </div>
      <h1 className="flex-1 text-center text-base font-bold truncate px-2">{title}</h1>
      <div className={right ? "flex justify-end" : "w-10"} style={side}>{right}</div>
    </div>
  );
}
